export default "__VITE_ASSET__Biba78R2__"